// Platform UI registry — drives the EventDrawer's per-platform rows.
// New platform onboarding = add a registry entry + an editor page; drawer
// renders the row for free by iterating event.publications and looking up
// the registry.
//
// hasOverrides    — does this platform have a per-event override editor at
//                   /event/:id/{editorPath}? Drives the "Configure →" link.
// hasDrift        — does the platform support drift detection? Drives the
//                   drift dot rendering.
// externalUrlField — which field on event_publications carries the URL ops
//                   would click "Open in {Platform} ↗" to. Null = no
//                   external link.

export const PLATFORMS = {
  universe: {
    label: 'Universe',
    short: 'U',
    editorPath: 'universe',
    hasOverrides: true,
    hasDrift: true,
    externalUrlField: 'external_url',
  },
  urvenue: {
    label: 'UrVenue',
    short: 'V',
    editorPath: 'urvenue',
    hasOverrides: true,
    hasDrift: true,
    externalUrlField: 'external_url',
  },
  meta: {
    label: 'Meta',
    short: 'M',
    editorPath: null,        // Phase C4
    hasOverrides: false,
    hasDrift: false,
    externalUrlField: 'external_url',
  },
  monday_video_promo: {
    label: 'Monday · Video Promo',
    short: 'Mp',
    editorPath: null,        // Phase C5
    hasOverrides: false,
    hasDrift: false,
    externalUrlField: 'external_url',
  },
  monday_video_ad: {
    label: 'Monday · Video Ad',
    short: 'Mv',
    editorPath: null,
    hasOverrides: false,
    hasDrift: false,
    externalUrlField: 'external_url',
  },
  monday_ad: {
    label: 'Monday · Ad',
    short: 'Ma',
    editorPath: null,
    hasOverrides: false,
    hasDrift: false,
    externalUrlField: 'external_url',
  },
  // Out-of-home advertising — tracked manually (status manual_only, no
  // external_id/url, no publisher). Read-only rows in the drawer.
  billboard: {
    label: 'Billboard',
    short: 'BB',
    editorPath: null,
    hasOverrides: false,
    hasDrift: false,
    externalUrlField: null,
  },
  led: {
    label: 'LED',
    short: 'LED',
    editorPath: null,
    hasOverrides: false,
    hasDrift: false,
    externalUrlField: null,
  },

  // Discovery distribution (server/publishers/distribution) — listing
  // syndication. Read-only here; no per-event override surface yet.
  bandsintown: {
    label: 'Bandsintown', short: 'BIT', editorPath: null,
    hasOverrides: false, hasDrift: false, externalUrlField: 'external_url',
  },
  resident_advisor: {
    label: 'Resident Advisor', short: 'RA', editorPath: null,
    hasOverrides: false, hasDrift: false, externalUrlField: 'external_url',
  },
  jambase: {
    label: 'JamBase', short: 'JB', editorPath: null,
    hasOverrides: false, hasDrift: false, externalUrlField: 'external_url',
  },
  // TicketWeb shell events (feed ticketmaster.com, redirect to LIV site).
  ticketweb: {
    label: 'TicketWeb', short: 'TW', editorPath: null,
    hasOverrides: false, hasDrift: false, externalUrlField: 'external_url',
  },

  // Future ticketing platforms — register when contracts land:
  // dice, tixr, speakeasy, ticketmaster
};

// Look up registry entry for a platform key; falls back to a minimal
// generic entry so unknown platforms don't crash the drawer.
export function platformMeta(key) {
  return PLATFORMS[key] || {
    label: key,
    short: '?',
    editorPath: null,
    hasOverrides: false,
    hasDrift: false,
    externalUrlField: 'external_url',
  };
}

// Sync status pill copy + tone per event_publications.status. Centralized
// so drawer + EventDetail render the same labels.
export const PUB_STATUS_TONE = {
  published:   { label: 'synced',    cls: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-300' },
  manual_only: { label: 'manual',    cls: 'bg-amber-400/15 text-amber-700 dark:text-amber-400' },
  pending:     { label: 'pending',   cls: 'bg-muted-foreground/15 text-muted-foreground' },
  failed:      { label: 'failed',    cls: 'bg-red-500/15 text-red-700 dark:text-red-300' },
  unpublished: { label: 'unpub',     cls: 'bg-muted text-muted-foreground' },
};
